export default {
    '6500': 'POBNSKBA',
    '8420': 'BFKKSKBB',
    '8130': 'CITISKBA',
    '8050': 'COBASKBX',
    '7500': 'CEKOSKBX',
    '8170': 'KBSPSKBX',
    '5600': 'KOMASK2X',
    '8160': 'EXSKSKBX',
    '8330': 'FIOZSKBA',
    '7300': 'INGBSKBX',
    '8320': 'JTBPSKBA',
    '8100': 'KOMBSKBA',
    '8360': 'BREXSKBX',
    '0720': 'NBSBSKBX',
    '8370': 'OBKLSKBA',
    '5200': 'OTPVSKBX',
    '8120': 'BSLOSK22',
    '5900': 'PRVASKBA',
    '0900': 'GIBASKBX',
    '3000': 'SLZBSKBA',
    '8180': 'SPSRSKBA',
    '1100': 'TATRSKBX',
    '1111': 'UNCRSKBX',
    '0200': 'SUBASKBX',
    '7930': 'WUSTSKBA',
    '8430': 'KODBSKBX'
}